export default "__VITE_ASSET__Bru9gKtQ__"